import Axios from "axios";
import { tokenStorage } from "@/domain/auth/token-storage";
import { getRequiredApiBaseUrl } from "@/config/api";

declare module "axios" {
  export interface AxiosRequestConfig {
    /** When true, response interceptor skips the generic error toast. */
    skipErrorToast?: boolean;
  }
}

const source = Axios.CancelToken.source();
const baseUrl = `${getRequiredApiBaseUrl()}/api/`;

const API = Axios.create({
  baseURL: baseUrl,
  timeout: 30000,
  cancelToken: source.token,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

API.interceptors.request.use((config) => {
  const token = tokenStorage.getAccessToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default API;
